import { NgModule } from '@angular/core';
import { FeatherModule } from 'angular-feather';
import {
    AlertTriangle,
    Award,
    Mail,
    Calendar,
    ChevronRight,
    ChevronLeft,
    ChevronUp,
    ChevronDown,
    Check,
    Download,
    Filter,
    Clock,
    Heart,
    Tool,
    X,
    PlusCircle,
    MinusCircle,
    MessageSquare,
    MessageCircle,
    Maximize,
    Star,
} from 'angular-feather/icons';

// Feather has no flame. FeatherModule.pick() takes plain SVG strings and <i-feather> resolves
// `name` by upper-camel-casing it, so this registers as name="flame". Stroke, fill and
// line caps come from the i-feather host styles, matching the built-in icons.
const Flame =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="feather feather-flame"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>';

const icons = {
    Mail,
    Calendar,
    ChevronRight,
    ChevronLeft,
    ChevronUp,
    ChevronDown,
    Clock,
    Heart,
    Filter,
    Download,
    Tool,
    X,
    PlusCircle,
    MinusCircle,
    MessageSquare,
    MessageCircle,
    Maximize,
    Check,
    // Featured Solution Tags
    AlertTriangle,
    Award,
    Flame,
    Star,
};

@NgModule({
    imports: [FeatherModule.pick(icons)],
    exports: [FeatherModule],
})
export class IconsModule {}
